import React from 'react';
import { Shield, Lock, Database, Zap } from 'lucide-react';

const TierServicesSection = () => {
  const competencies = [
  { icon: Shield, title: 'AWS Advanced', subtitle: "Cloud Consulting Services" },
  { icon: Lock, title: 'Security', subtitle: 'Competency' },
  { icon: Database, title: 'Data & Analytics', subtitle: 'Competency' },
  { icon: Zap, title: 'DevOps', subtitle: 'Competency' }];


  return (
    <section className="py-16 bg-gradient-to-b from-[#061426] to-[#020B1A]">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-2xl font-bold text-center text-cyan-400 mb-12">AWS Cloud Solutions

        </h2>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {competencies.map((competency, index) => {
            const Icon = competency.icon;
            return (
              <div
                key={index}
                className="flex flex-col items-center text-center group cursor-pointer transition-transform duration-300 hover:scale-105">

                <div
                  className="w-16 h-16 bg-gradient-to-br from-cyan-500/20 to-blue-600/20 border border-cyan-500/30 rounded-full flex items-center justify-center mb-4 group-hover:border-cyan-400 transition-all duration-300"
                  style={{ boxShadow: '0 0 20px rgba(0, 212, 255, 0.2)' }}>

                  <Icon className="w-8 h-8 text-cyan-400 group-hover:text-cyan-300 transition-colors duration-300" />
                </div>
                <h3 className="text-lg font-bold text-white mb-1">{competency.title}</h3>
                <p className="text-sm text-gray-400">{competency.subtitle}</p>
              </div>);

          })}
        </div>
      </div>
    </section>);

};

export default TierServicesSection;